export default {
  SET_CURRENT_USER (state, user) {
    const { fullname, technischerKontakt, email } = user

    if (fullname) {
      const initials = fullname.split(' ').map(str => str.charAt(0)).join().replace(',', '')
      user.initials = initials
      user.technischerKontakt = technischerKontakt
      user.email = email
    }

    state.currentUser = { ...user }
  },
  SET_IS_LOGGED_IN (state, loggedInState) {
    state.loggedInState = loggedInState
  },
  SET_IS_AUTHCODE_PAGE_VISIBLE (state, visibleState) {
    state.isAuthCodePageVisible = visibleState
  },
  SET_SMS_SENDER_RESULT (state, number) {
    state.tempPhoneNumber = number
  }
}
